import React, { createContext, useContext, useEffect, useState } from 'react';
import { getProfilePicture, getUserSelfInfo } from '../services/userSelfInfo.api';
const ProfileContext = createContext();

export function useProfile() {
  return useContext(ProfileContext);
}

export function ProfileProvider({ children }) {
  const [profilePictureUrl, setProfilePictureUrl] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    let isMounted = true;
    async function fetchProfilePicture() {
      setLoading(true);
      setError(null);
      try {
        const response = await getProfilePicture();
        const blob = await response.blob();
        const imageUrl = URL.createObjectURL(blob);
        if (isMounted) setProfilePictureUrl(imageUrl);
      } catch (err) {
        if (isMounted) {
          setError(err.message);
          setProfilePictureUrl('');
        }
      } finally {
        if (isMounted) setLoading(false);
      }
    }
    async function fetchUserInfo() {
      try {
        const info = await getUserSelfInfo();
        if (isMounted) setUserInfo(info);
      } catch (err) {
        if (isMounted) setUserInfo(null);
      }
    }
    fetchProfilePicture();
    fetchUserInfo();
    return () => { isMounted = false; };
  }, []);

  return (
    <ProfileContext.Provider value={{ profilePictureUrl, loading, error, userInfo }}>
      {children}
    </ProfileContext.Provider>
  );
}
